import React, { useEffect, useState, useContext, useCallback } from 'react';

import { Container } from './styles';

import { GameContext } from '../../context/GameContext';
import House from '../House';


interface BoardProps {
  gameID: number;
  size: number;
  sizeHeight: number;
  title: string;
  text: string;
  direct: boolean;
}

const Board: React.FC<BoardProps> = ({ direct, sizeHeight }) => {
  const {
    state: { GameState, GameTemplate },
    state,
    dispatch,
  } = useContext(GameContext);

  const width = direct ? .88 : .7;
  const [rowCoords, setRowCoord] = useState<number[]>([]);
  const [houseSize, setHouseSize] = useState<number>(((width * window.innerHeight) / sizeHeight));

  useEffect(() => {
    window.addEventListener("resize", () => {
      //console.log("resize")
      setHouseSize(((width * window.innerHeight) / sizeHeight));
    });
    return () => {
      window.removeEventListener("resize", () => { })
    }
  }, [])

  const getRowPosition = useCallback((rowCoord, row) => {
    var newRowCoord = rowCoords;
    newRowCoord.push(rowCoord);
    setRowCoord(newRowCoord);
  }, [rowCoords]);


  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* <TextContainer>
        <Title>{title}</Title>
        <Text>{text}</Text>
      </TextContainer> */}
      <Container direct={direct}>
        {GameTemplate.matrix.map((row, rowIndex) => (
          <div key={rowIndex} className="row">
            {row.map((cell, columnIndex) => (
              <House key={columnIndex} x={rowIndex} y={columnIndex} houseSize={houseSize} direct={direct}></House>
            ))}
          </div>
        ))}

      </Container>
    </div>
  );
}

export default Board;

